// @ts-nocheck


export const routes = {
  "meta": {},
  "id": "_default",
  "name": "",
  "file": {
    "path": "src/routes/_module.svelte",
    "dir": "src/routes",
    "base": "_module.svelte",
    "ext": ".svelte",
    "name": "_module"
  },
  "asyncModule": () => import('../src/routes/_module.svelte'),
  "rootName": "default",
  "routifyDir": import.meta.url,
  "children": [
    {
      "meta": {
        "fallback": true,
        "order": false,
        "noRoute": true
      },
      "id": "_default__fallback_svelte",
      "name": "_fallback",
      "file": {
        "path": "src/routes/_fallback.svelte",
        "dir": "src/routes",
        "base": "_fallback.svelte",
        "ext": ".svelte",
        "name": "_fallback"
      },
      "asyncModule": () => import('../src/routes/_fallback.svelte'),
      "children": []
    },
    {
      "meta": {
        "noRoute": true
      },
      "id": "_default__footer",
      "name": "_footer",
      "module": false,
      "file": {
        "path": "src/routes/_footer",
        "dir": "src/routes",
        "base": "_footer",
        "ext": "",
        "name": "_footer"
      },
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default__footer_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/_footer/index.svelte",
            "dir": "src/routes/_footer",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/_footer/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {
        "noRoute": true
      },
      "id": "_default__header",
      "name": "_header",
      "module": false,
      "file": {
        "path": "src/routes/_header",
        "dir": "src/routes",
        "base": "_header",
        "ext": "",
        "name": "_header"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default__header__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/_header/_components",
            "dir": "src/routes/_header",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default__header__components_localeChanger_svelte",
              "name": "localeChanger",
              "file": {
                "path": "src/routes/_header/_components/localeChanger.svelte",
                "dir": "src/routes/_header/_components",
                "base": "localeChanger.svelte",
                "ext": ".svelte",
                "name": "localeChanger"
              },
              "asyncModule": () => import('../src/routes/_header/_components/localeChanger.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default__header__components_search_asset_svelte",
              "name": "search-asset",
              "file": {
                "path": "src/routes/_header/_components/search-asset.svelte",
                "dir": "src/routes/_header/_components",
                "base": "search-asset.svelte",
                "ext": ".svelte",
                "name": "search-asset"
              },
              "asyncModule": () => import('../src/routes/_header/_components/search-asset.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default__header_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/_header/index.svelte",
            "dir": "src/routes/_header",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/_header/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {
        "noRoute": true
      },
      "id": "_default__sidebar",
      "name": "_sidebar",
      "module": false,
      "file": {
        "path": "src/routes/_sidebar",
        "dir": "src/routes",
        "base": "_sidebar",
        "ext": "",
        "name": "_sidebar"
      },
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default__sidebar_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/_sidebar/index.svelte",
            "dir": "src/routes/_sidebar",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/_sidebar/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {
        "noRoute": true
      },
      "id": "_default__summary",
      "name": "_summary",
      "module": false,
      "file": {
        "path": "src/routes/_summary",
        "dir": "src/routes",
        "base": "_summary",
        "ext": "",
        "name": "_summary"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default__summary__form_svelte",
          "name": "_form",
          "file": {
            "path": "src/routes/_summary/_form.svelte",
            "dir": "src/routes/_summary",
            "base": "_form.svelte",
            "ext": ".svelte",
            "name": "_form"
          },
          "asyncModule": () => import('../src/routes/_summary/_form.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_asset",
      "name": "asset",
      "module": false,
      "file": {
        "path": "src/routes/asset",
        "dir": "src/routes",
        "base": "asset",
        "ext": "",
        "name": "asset"
      },
      "children": [
        {
          "meta": {
            "dynamic": true,
            "order": false
          },
          "id": "_default_asset__kind_",
          "name": "[kind]",
          "module": false,
          "file": {
            "path": "src/routes/asset/[kind]",
            "dir": "src/routes/asset",
            "base": "[kind]",
            "ext": "",
            "name": "[kind]"
          },
          "children": [
            {
              "meta": {
                "dynamic": true,
                "order": false
              },
              "id": "_default_asset__kind___id_",
              "name": "[id]",
              "module": false,
              "file": {
                "path": "src/routes/asset/[kind]/[id]",
                "dir": "src/routes/asset/[kind]",
                "base": "[id]",
                "ext": "",
                "name": "[id]"
              },
              "children": [
                {
                  "meta": {
                    "noRoute": true
                  },
                  "id": "_default_asset__kind___id___components",
                  "name": "_components",
                  "module": false,
                  "file": {
                    "path": "src/routes/asset/[kind]/[id]/_components",
                    "dir": "src/routes/asset/[kind]/[id]",
                    "base": "_components",
                    "ext": "",
                    "name": "_components"
                  },
                  "children": [
                    {
                      "meta": {},
                      "id": "_default_asset__kind___id___components_asset_detail_svelte",
                      "name": "asset-detail",
                      "file": {
                        "path": "src/routes/asset/[kind]/[id]/_components/asset-detail.svelte",
                        "dir": "src/routes/asset/[kind]/[id]/_components",
                        "base": "asset-detail.svelte",
                        "ext": ".svelte",
                        "name": "asset-detail"
                      },
                      "asyncModule": () => import('../src/routes/asset/[kind]/[id]/_components/asset-detail.svelte'),
                      "children": []
                    },
                    {
                      "meta": {},
                      "id": "_default_asset__kind___id___components_asset_relations_svelte",
                      "name": "asset-relations",
                      "file": {
                        "path": "src/routes/asset/[kind]/[id]/_components/asset-relations.svelte",
                        "dir": "src/routes/asset/[kind]/[id]/_components",
                        "base": "asset-relations.svelte",
                        "ext": ".svelte",
                        "name": "asset-relations"
                      },
                      "asyncModule": () => import('../src/routes/asset/[kind]/[id]/_components/asset-relations.svelte'),
                      "children": []
                    },
                    {
                      "meta": {},
                      "id": "_default_asset__kind___id___components_severity_totals_svelte",
                      "name": "severity-totals",
                      "file": {
                        "path": "src/routes/asset/[kind]/[id]/_components/severity-totals.svelte",
                        "dir": "src/routes/asset/[kind]/[id]/_components",
                        "base": "severity-totals.svelte",
                        "ext": ".svelte",
                        "name": "severity-totals"
                      },
                      "asyncModule": () => import('../src/routes/asset/[kind]/[id]/_components/severity-totals.svelte'),
                      "children": []
                    }
                  ]
                },
                {
                  "meta": {
                    "isDefault": true
                  },
                  "id": "_default_asset__kind___id__index_svelte",
                  "name": "index",
                  "file": {
                    "path": "src/routes/asset/[kind]/[id]/index.svelte",
                    "dir": "src/routes/asset/[kind]/[id]",
                    "base": "index.svelte",
                    "ext": ".svelte",
                    "name": "index"
                  },
                  "asyncModule": () => import('../src/routes/asset/[kind]/[id]/index.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_asset__kind__index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/asset/[kind]/index.svelte",
                "dir": "src/routes/asset/[kind]",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/asset/[kind]/index.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_asset__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/asset/_components",
            "dir": "src/routes/asset",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_asset__components_asset_count_svelte",
              "name": "asset-count",
              "file": {
                "path": "src/routes/asset/_components/asset-count.svelte",
                "dir": "src/routes/asset/_components",
                "base": "asset-count.svelte",
                "ext": ".svelte",
                "name": "asset-count"
              },
              "asyncModule": () => import('../src/routes/asset/_components/asset-count.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_asset__components_list_svelte",
              "name": "list",
              "file": {
                "path": "src/routes/asset/_components/list.svelte",
                "dir": "src/routes/asset/_components",
                "base": "list.svelte",
                "ext": ".svelte",
                "name": "list"
              },
              "asyncModule": () => import('../src/routes/asset/_components/list.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_asset__components_remove_asset_tag_svelte",
              "name": "remove-asset-tag",
              "file": {
                "path": "src/routes/asset/_components/remove-asset-tag.svelte",
                "dir": "src/routes/asset/_components",
                "base": "remove-asset-tag.svelte",
                "ext": ".svelte",
                "name": "remove-asset-tag"
              },
              "asyncModule": () => import('../src/routes/asset/_components/remove-asset-tag.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_asset__form_svelte",
          "name": "_form",
          "file": {
            "path": "src/routes/asset/_form.svelte",
            "dir": "src/routes/asset",
            "base": "_form.svelte",
            "ext": ".svelte",
            "name": "_form"
          },
          "asyncModule": () => import('../src/routes/asset/_form.svelte'),
          "children": []
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_asset__form_kind_svelte",
          "name": "_form_kind",
          "file": {
            "path": "src/routes/asset/_form_kind.svelte",
            "dir": "src/routes/asset",
            "base": "_form_kind.svelte",
            "ext": ".svelte",
            "name": "_form_kind"
          },
          "asyncModule": () => import('../src/routes/asset/_form_kind.svelte'),
          "children": []
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_asset__form_massive_add_svelte",
          "name": "_form_massive_add",
          "file": {
            "path": "src/routes/asset/_form_massive_add.svelte",
            "dir": "src/routes/asset",
            "base": "_form_massive_add.svelte",
            "ext": ".svelte",
            "name": "_form_massive_add"
          },
          "asyncModule": () => import('../src/routes/asset/_form_massive_add.svelte'),
          "children": []
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_asset__form_massive_edit_svelte",
          "name": "_form_massive_edit",
          "file": {
            "path": "src/routes/asset/_form_massive_edit.svelte",
            "dir": "src/routes/asset",
            "base": "_form_massive_edit.svelte",
            "ext": ".svelte",
            "name": "_form_massive_edit"
          },
          "asyncModule": () => import('../src/routes/asset/_form_massive_edit.svelte'),
          "children": []
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_asset_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/asset/index.svelte",
            "dir": "src/routes/asset",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/asset/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_billing",
      "name": "billing",
      "module": false,
      "file": {
        "path": "src/routes/billing",
        "dir": "src/routes",
        "base": "billing",
        "ext": "",
        "name": "billing"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_billing__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/billing/_components",
            "dir": "src/routes/billing",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_billing__components_v2_list_svelte",
              "name": "v2-list",
              "file": {
                "path": "src/routes/billing/_components/v2-list.svelte",
                "dir": "src/routes/billing/_components",
                "base": "v2-list.svelte",
                "ext": ".svelte",
                "name": "v2-list"
              },
              "asyncModule": () => import('../src/routes/billing/_components/v2-list.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_billing_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/billing/index.svelte",
            "dir": "src/routes/billing",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/billing/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_certificate",
      "name": "certificate",
      "module": false,
      "file": {
        "path": "src/routes/certificate",
        "dir": "src/routes",
        "base": "certificate",
        "ext": "",
        "name": "certificate"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_certificate__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/certificate/_components",
            "dir": "src/routes/certificate",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_certificate__components_certsByAssetKind_svelte",
              "name": "certsByAssetKind",
              "file": {
                "path": "src/routes/certificate/_components/certsByAssetKind.svelte",
                "dir": "src/routes/certificate/_components",
                "base": "certsByAssetKind.svelte",
                "ext": ".svelte",
                "name": "certsByAssetKind"
              },
              "asyncModule": () => import('../src/routes/certificate/_components/certsByAssetKind.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_certificate__components_issuerTopFive_svelte",
              "name": "issuerTopFive",
              "file": {
                "path": "src/routes/certificate/_components/issuerTopFive.svelte",
                "dir": "src/routes/certificate/_components",
                "base": "issuerTopFive.svelte",
                "ext": ".svelte",
                "name": "issuerTopFive"
              },
              "asyncModule": () => import('../src/routes/certificate/_components/issuerTopFive.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_certificate_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/certificate/index.svelte",
            "dir": "src/routes/certificate",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/certificate/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_dashboard",
      "name": "dashboard",
      "module": false,
      "file": {
        "path": "src/routes/dashboard",
        "dir": "src/routes",
        "base": "dashboard",
        "ext": "",
        "name": "dashboard"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_dashboard__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/dashboard/_components",
            "dir": "src/routes/dashboard",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_dashboard__components_daily_max_count_svelte",
              "name": "daily-max-count",
              "file": {
                "path": "src/routes/dashboard/_components/daily-max-count.svelte",
                "dir": "src/routes/dashboard/_components",
                "base": "daily-max-count.svelte",
                "ext": ".svelte",
                "name": "daily-max-count"
              },
              "asyncModule": () => import('../src/routes/dashboard/_components/daily-max-count.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_dashboard__components_findings_by_age_svelte",
              "name": "findings-by-age",
              "file": {
                "path": "src/routes/dashboard/_components/findings-by-age.svelte",
                "dir": "src/routes/dashboard/_components",
                "base": "findings-by-age.svelte",
                "ext": ".svelte",
                "name": "findings-by-age"
              },
              "asyncModule": () => import('../src/routes/dashboard/_components/findings-by-age.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_dashboard__components_findings_by_severity_svelte",
              "name": "findings-by-severity",
              "file": {
                "path": "src/routes/dashboard/_components/findings-by-severity.svelte",
                "dir": "src/routes/dashboard/_components",
                "base": "findings-by-severity.svelte",
                "ext": ".svelte",
                "name": "findings-by-severity"
              },
              "asyncModule": () => import('../src/routes/dashboard/_components/findings-by-severity.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_dashboard__components_status_max_count_svelte",
              "name": "status-max-count",
              "file": {
                "path": "src/routes/dashboard/_components/status-max-count.svelte",
                "dir": "src/routes/dashboard/_components",
                "base": "status-max-count.svelte",
                "ext": ".svelte",
                "name": "status-max-count"
              },
              "asyncModule": () => import('../src/routes/dashboard/_components/status-max-count.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_dashboard_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/dashboard/index.svelte",
            "dir": "src/routes/dashboard",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/dashboard/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_finding",
      "name": "finding",
      "module": false,
      "file": {
        "path": "src/routes/finding",
        "dir": "src/routes",
        "base": "finding",
        "ext": "",
        "name": "finding"
      },
      "children": [
        {
          "meta": {
            "dynamic": true,
            "order": false
          },
          "id": "_default_finding__id_",
          "name": "[id]",
          "module": false,
          "file": {
            "path": "src/routes/finding/[id]",
            "dir": "src/routes/finding",
            "base": "[id]",
            "ext": "",
            "name": "[id]"
          },
          "children": [
            {
              "meta": {
                "noRoute": true
              },
              "id": "_default_finding__id___components",
              "name": "_components",
              "module": false,
              "file": {
                "path": "src/routes/finding/[id]/_components",
                "dir": "src/routes/finding/[id]",
                "base": "_components",
                "ext": "",
                "name": "_components"
              },
              "children": [
                {
                  "meta": {},
                  "id": "_default_finding__id___components_finding_detail_svelte",
                  "name": "finding-detail",
                  "file": {
                    "path": "src/routes/finding/[id]/_components/finding-detail.svelte",
                    "dir": "src/routes/finding/[id]/_components",
                    "base": "finding-detail.svelte",
                    "ext": ".svelte",
                    "name": "finding-detail"
                  },
                  "asyncModule": () => import('../src/routes/finding/[id]/_components/finding-detail.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_finding__id__index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/finding/[id]/index.svelte",
                "dir": "src/routes/finding/[id]",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/finding/[id]/index.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_finding__add_props_form_svelte",
          "name": "_add_props_form",
          "file": {
            "path": "src/routes/finding/_add_props_form.svelte",
            "dir": "src/routes/finding",
            "base": "_add_props_form.svelte",
            "ext": ".svelte",
            "name": "_add_props_form"
          },
          "asyncModule": () => import('../src/routes/finding/_add_props_form.svelte'),
          "children": []
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_finding__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/finding/_components",
            "dir": "src/routes/finding",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_finding__components_asset_detail_expanded_svelte",
              "name": "asset-detail-expanded",
              "file": {
                "path": "src/routes/finding/_components/asset-detail-expanded.svelte",
                "dir": "src/routes/finding/_components",
                "base": "asset-detail-expanded.svelte",
                "ext": ".svelte",
                "name": "asset-detail-expanded"
              },
              "asyncModule": () => import('../src/routes/finding/_components/asset-detail-expanded.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_evidences_svelte",
              "name": "evidences",
              "file": {
                "path": "src/routes/finding/_components/evidences.svelte",
                "dir": "src/routes/finding/_components",
                "base": "evidences.svelte",
                "ext": ".svelte",
                "name": "evidences"
              },
              "asyncModule": () => import('../src/routes/finding/_components/evidences.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_finding_count_svelte",
              "name": "finding-count",
              "file": {
                "path": "src/routes/finding/_components/finding-count.svelte",
                "dir": "src/routes/finding/_components",
                "base": "finding-count.svelte",
                "ext": ".svelte",
                "name": "finding-count"
              },
              "asyncModule": () => import('../src/routes/finding/_components/finding-count.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_findings_by_asset_kind_svelte",
              "name": "findings-by-asset-kind",
              "file": {
                "path": "src/routes/finding/_components/findings-by-asset-kind.svelte",
                "dir": "src/routes/finding/_components",
                "base": "findings-by-asset-kind.svelte",
                "ext": ".svelte",
                "name": "findings-by-asset-kind"
              },
              "asyncModule": () => import('../src/routes/finding/_components/findings-by-asset-kind.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_findings_by_severity_svelte",
              "name": "findings-by-severity",
              "file": {
                "path": "src/routes/finding/_components/findings-by-severity.svelte",
                "dir": "src/routes/finding/_components",
                "base": "findings-by-severity.svelte",
                "ext": ".svelte",
                "name": "findings-by-severity"
              },
              "asyncModule": () => import('../src/routes/finding/_components/findings-by-severity.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_findings_by_vul_kind_svelte",
              "name": "findings-by-vul-kind",
              "file": {
                "path": "src/routes/finding/_components/findings-by-vul-kind.svelte",
                "dir": "src/routes/finding/_components",
                "base": "findings-by-vul-kind.svelte",
                "ext": ".svelte",
                "name": "findings-by-vul-kind"
              },
              "asyncModule": () => import('../src/routes/finding/_components/findings-by-vul-kind.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_findings_by_vulnerablity_svelte",
              "name": "findings-by-vulnerablity",
              "file": {
                "path": "src/routes/finding/_components/findings-by-vulnerablity.svelte",
                "dir": "src/routes/finding/_components",
                "base": "findings-by-vulnerablity.svelte",
                "ext": ".svelte",
                "name": "findings-by-vulnerablity"
              },
              "asyncModule": () => import('../src/routes/finding/_components/findings-by-vulnerablity.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_gallery_svelte",
              "name": "gallery",
              "file": {
                "path": "src/routes/finding/_components/gallery.svelte",
                "dir": "src/routes/finding/_components",
                "base": "gallery.svelte",
                "ext": ".svelte",
                "name": "gallery"
              },
              "asyncModule": () => import('../src/routes/finding/_components/gallery.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_list_svelte",
              "name": "list",
              "file": {
                "path": "src/routes/finding/_components/list.svelte",
                "dir": "src/routes/finding/_components",
                "base": "list.svelte",
                "ext": ".svelte",
                "name": "list"
              },
              "asyncModule": () => import('../src/routes/finding/_components/list.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_remove_finding_tag_svelte",
              "name": "remove-finding-tag",
              "file": {
                "path": "src/routes/finding/_components/remove-finding-tag.svelte",
                "dir": "src/routes/finding/_components",
                "base": "remove-finding-tag.svelte",
                "ext": ".svelte",
                "name": "remove-finding-tag"
              },
              "asyncModule": () => import('../src/routes/finding/_components/remove-finding-tag.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_finding__components_search_results_svelte",
              "name": "search-results",
              "file": {
                "path": "src/routes/finding/_components/search-results.svelte",
                "dir": "src/routes/finding/_components",
                "base": "search-results.svelte",
                "ext": ".svelte",
                "name": "search-results"
              },
              "asyncModule": () => import('../src/routes/finding/_components/search-results.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_finding__delete_props_form_svelte",
          "name": "_delete_props_form",
          "file": {
            "path": "src/routes/finding/_delete_props_form.svelte",
            "dir": "src/routes/finding",
            "base": "_delete_props_form.svelte",
            "ext": ".svelte",
            "name": "_delete_props_form"
          },
          "asyncModule": () => import('../src/routes/finding/_delete_props_form.svelte'),
          "children": []
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_finding__edit_form_svelte",
          "name": "_edit_form",
          "file": {
            "path": "src/routes/finding/_edit_form.svelte",
            "dir": "src/routes/finding",
            "base": "_edit_form.svelte",
            "ext": ".svelte",
            "name": "_edit_form"
          },
          "asyncModule": () => import('../src/routes/finding/_edit_form.svelte'),
          "children": []
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_finding__form_svelte",
          "name": "_form",
          "file": {
            "path": "src/routes/finding/_form.svelte",
            "dir": "src/routes/finding",
            "base": "_form.svelte",
            "ext": ".svelte",
            "name": "_form"
          },
          "asyncModule": () => import('../src/routes/finding/_form.svelte'),
          "children": []
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_finding_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/finding/index.svelte",
            "dir": "src/routes/finding",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/finding/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {
        "isDefault": true
      },
      "id": "_default_index_svelte",
      "name": "index",
      "file": {
        "path": "src/routes/index.svelte",
        "dir": "src/routes",
        "base": "index.svelte",
        "ext": ".svelte",
        "name": "index"
      },
      "asyncModule": () => import('../src/routes/index.svelte'),
      "children": []
    },
    {
      "meta": {},
      "id": "_default_integration",
      "name": "integration",
      "module": false,
      "file": {
        "path": "src/routes/integration",
        "dir": "src/routes",
        "base": "integration",
        "ext": "",
        "name": "integration"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_integration__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/integration/_components",
            "dir": "src/routes/integration",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_integration__components_v2_list_svelte",
              "name": "v2-list",
              "file": {
                "path": "src/routes/integration/_components/v2-list.svelte",
                "dir": "src/routes/integration/_components",
                "base": "v2-list.svelte",
                "ext": ".svelte",
                "name": "v2-list"
              },
              "asyncModule": () => import('../src/routes/integration/_components/v2-list.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_integration__form_svelte",
          "name": "_form",
          "file": {
            "path": "src/routes/integration/_form.svelte",
            "dir": "src/routes/integration",
            "base": "_form.svelte",
            "ext": ".svelte",
            "name": "_form"
          },
          "asyncModule": () => import('../src/routes/integration/_form.svelte'),
          "children": []
        },
        {
          "meta": {},
          "id": "_default_integration_agent",
          "name": "agent",
          "module": false,
          "file": {
            "path": "src/routes/integration/agent",
            "dir": "src/routes/integration",
            "base": "agent",
            "ext": "",
            "name": "agent"
          },
          "children": [
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_integration_agent_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/integration/agent/index.svelte",
                "dir": "src/routes/integration/agent",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/integration/agent/index.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_integration_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/integration/index.svelte",
            "dir": "src/routes/integration",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/integration/index.svelte'),
          "children": []
        },
        {
          "meta": {},
          "id": "_default_integration_scanner",
          "name": "scanner",
          "module": false,
          "file": {
            "path": "src/routes/integration/scanner",
            "dir": "src/routes/integration",
            "base": "scanner",
            "ext": "",
            "name": "scanner"
          },
          "children": [
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_integration_scanner_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/integration/scanner/index.svelte",
                "dir": "src/routes/integration/scanner",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/integration/scanner/index.svelte'),
              "children": []
            }
          ]
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_log",
      "name": "log",
      "module": false,
      "file": {
        "path": "src/routes/log",
        "dir": "src/routes",
        "base": "log",
        "ext": "",
        "name": "log"
      },
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_log_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/log/index.svelte",
            "dir": "src/routes/log",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/log/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {
        "reset": true
      },
      "id": "_default_login",
      "name": "login",
      "file": {
        "path": "src/routes/login/_reset.svelte",
        "dir": "src/routes/login",
        "base": "_reset.svelte",
        "ext": ".svelte",
        "name": "_reset"
      },
      "asyncModule": () => import('../src/routes/login/_reset.svelte'),
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_login__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/login/_components",
            "dir": "src/routes/login",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_login__components_modal_svelte",
              "name": "modal",
              "file": {
                "path": "src/routes/login/_components/modal.svelte",
                "dir": "src/routes/login/_components",
                "base": "modal.svelte",
                "ext": ".svelte",
                "name": "modal"
              },
              "asyncModule": () => import('../src/routes/login/_components/modal.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_login_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/login/index.svelte",
            "dir": "src/routes/login",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/login/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_me",
      "name": "me",
      "module": false,
      "file": {
        "path": "src/routes/me",
        "dir": "src/routes",
        "base": "me",
        "ext": "",
        "name": "me"
      },
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_me_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/me/index.svelte",
            "dir": "src/routes/me",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/me/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {
        "reset": true
      },
      "id": "_default_otac",
      "name": "otac",
      "file": {
        "path": "src/routes/otac/_reset.svelte",
        "dir": "src/routes/otac",
        "base": "_reset.svelte",
        "ext": ".svelte",
        "name": "_reset"
      },
      "asyncModule": () => import('../src/routes/otac/_reset.svelte'),
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_otac_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/otac/index.svelte",
            "dir": "src/routes/otac",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/otac/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_pentest",
      "name": "pentest",
      "module": false,
      "file": {
        "path": "src/routes/pentest",
        "dir": "src/routes",
        "base": "pentest",
        "ext": "",
        "name": "pentest"
      },
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_pentest_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/pentest/index.svelte",
            "dir": "src/routes/pentest",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/pentest/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_phishing",
      "name": "phishing",
      "module": false,
      "file": {
        "path": "src/routes/phishing",
        "dir": "src/routes",
        "base": "phishing",
        "ext": "",
        "name": "phishing"
      },
      "children": [
        {
          "meta": {},
          "id": "_default_phishing_campaign",
          "name": "campaign",
          "module": false,
          "file": {
            "path": "src/routes/phishing/campaign",
            "dir": "src/routes/phishing",
            "base": "campaign",
            "ext": "",
            "name": "campaign"
          },
          "children": [
            {
              "meta": {
                "noRoute": true
              },
              "id": "_default_phishing_campaign__components",
              "name": "_components",
              "module": false,
              "file": {
                "path": "src/routes/phishing/campaign/_components",
                "dir": "src/routes/phishing/campaign",
                "base": "_components",
                "ext": "",
                "name": "_components"
              },
              "children": [
                {
                  "meta": {},
                  "id": "_default_phishing_campaign__components_import_modal_svelte",
                  "name": "import-modal",
                  "file": {
                    "path": "src/routes/phishing/campaign/_components/import-modal.svelte",
                    "dir": "src/routes/phishing/campaign/_components",
                    "base": "import-modal.svelte",
                    "ext": ".svelte",
                    "name": "import-modal"
                  },
                  "asyncModule": () => import('../src/routes/phishing/campaign/_components/import-modal.svelte'),
                  "children": []
                },
                {
                  "meta": {},
                  "id": "_default_phishing_campaign__components_report_action_row_svelte",
                  "name": "report-action-row",
                  "file": {
                    "path": "src/routes/phishing/campaign/_components/report-action-row.svelte",
                    "dir": "src/routes/phishing/campaign/_components",
                    "base": "report-action-row.svelte",
                    "ext": ".svelte",
                    "name": "report-action-row"
                  },
                  "asyncModule": () => import('../src/routes/phishing/campaign/_components/report-action-row.svelte'),
                  "children": []
                },
                {
                  "meta": {},
                  "id": "_default_phishing_campaign__components_report_modal_svelte",
                  "name": "report-modal",
                  "file": {
                    "path": "src/routes/phishing/campaign/_components/report-modal.svelte",
                    "dir": "src/routes/phishing/campaign/_components",
                    "base": "report-modal.svelte",
                    "ext": ".svelte",
                    "name": "report-modal"
                  },
                  "asyncModule": () => import('../src/routes/phishing/campaign/_components/report-modal.svelte'),
                  "children": []
                },
                {
                  "meta": {},
                  "id": "_default_phishing_campaign__components_v2_list_svelte",
                  "name": "v2-list",
                  "file": {
                    "path": "src/routes/phishing/campaign/_components/v2-list.svelte",
                    "dir": "src/routes/phishing/campaign/_components",
                    "base": "v2-list.svelte",
                    "ext": ".svelte",
                    "name": "v2-list"
                  },
                  "asyncModule": () => import('../src/routes/phishing/campaign/_components/v2-list.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {
                "noRoute": true
              },
              "id": "_default_phishing_campaign__form_svelte",
              "name": "_form",
              "file": {
                "path": "src/routes/phishing/campaign/_form.svelte",
                "dir": "src/routes/phishing/campaign",
                "base": "_form.svelte",
                "ext": ".svelte",
                "name": "_form"
              },
              "asyncModule": () => import('../src/routes/phishing/campaign/_form.svelte'),
              "children": []
            },
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_phishing_campaign_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/phishing/campaign/index.svelte",
                "dir": "src/routes/phishing/campaign",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/phishing/campaign/index.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_phishing_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/phishing/index.svelte",
            "dir": "src/routes/phishing",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/phishing/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_plan",
      "name": "plan",
      "module": false,
      "file": {
        "path": "src/routes/plan",
        "dir": "src/routes",
        "base": "plan",
        "ext": "",
        "name": "plan"
      },
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_plan_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/plan/index.svelte",
            "dir": "src/routes/plan",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/plan/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_property",
      "name": "property",
      "module": false,
      "file": {
        "path": "src/routes/property",
        "dir": "src/routes",
        "base": "property",
        "ext": "",
        "name": "property"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_property__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/property/_components",
            "dir": "src/routes/property",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_property__components_count_by_prop_value_svelte",
              "name": "count-by-prop-value",
              "file": {
                "path": "src/routes/property/_components/count-by-prop-value.svelte",
                "dir": "src/routes/property/_components",
                "base": "count-by-prop-value.svelte",
                "ext": ".svelte",
                "name": "count-by-prop-value"
              },
              "asyncModule": () => import('../src/routes/property/_components/count-by-prop-value.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {},
          "id": "_default_property_asset",
          "name": "asset",
          "module": false,
          "file": {
            "path": "src/routes/property/asset",
            "dir": "src/routes/property",
            "base": "asset",
            "ext": "",
            "name": "asset"
          },
          "children": [
            {
              "meta": {
                "dynamic": true,
                "order": false
              },
              "id": "_default_property_asset__kind_",
              "name": "[kind]",
              "module": false,
              "file": {
                "path": "src/routes/property/asset/[kind]",
                "dir": "src/routes/property/asset",
                "base": "[kind]",
                "ext": "",
                "name": "[kind]"
              },
              "children": [
                {
                  "meta": {
                    "dynamic": true,
                    "order": false
                  },
                  "id": "_default_property_asset__kind___name_",
                  "name": "[name]",
                  "module": false,
                  "file": {
                    "path": "src/routes/property/asset/[kind]/[name]",
                    "dir": "src/routes/property/asset/[kind]",
                    "base": "[name]",
                    "ext": "",
                    "name": "[name]"
                  },
                  "children": [
                    {
                      "meta": {
                        "isDefault": true
                      },
                      "id": "_default_property_asset__kind___name__index_svelte",
                      "name": "index",
                      "file": {
                        "path": "src/routes/property/asset/[kind]/[name]/index.svelte",
                        "dir": "src/routes/property/asset/[kind]/[name]",
                        "base": "index.svelte",
                        "ext": ".svelte",
                        "name": "index"
                      },
                      "asyncModule": () => import('../src/routes/property/asset/[kind]/[name]/index.svelte'),
                      "children": []
                    },
                    {
                      "meta": {},
                      "id": "_default_property_asset__kind___name__values",
                      "name": "values",
                      "module": false,
                      "file": {
                        "path": "src/routes/property/asset/[kind]/[name]/values",
                        "dir": "src/routes/property/asset/[kind]/[name]",
                        "base": "values",
                        "ext": "",
                        "name": "values"
                      },
                      "children": [
                        {
                          "meta": {
                            "isDefault": true
                          },
                          "id": "_default_property_asset__kind___name__values_index_svelte",
                          "name": "index",
                          "file": {
                            "path": "src/routes/property/asset/[kind]/[name]/values/index.svelte",
                            "dir": "src/routes/property/asset/[kind]/[name]/values",
                            "base": "index.svelte",
                            "ext": ".svelte",
                            "name": "index"
                          },
                          "asyncModule": () => import('../src/routes/property/asset/[kind]/[name]/values/index.svelte'),
                          "children": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "meta": {
                    "isDefault": true
                  },
                  "id": "_default_property_asset__kind__index_svelte",
                  "name": "index",
                  "file": {
                    "path": "src/routes/property/asset/[kind]/index.svelte",
                    "dir": "src/routes/property/asset/[kind]",
                    "base": "index.svelte",
                    "ext": ".svelte",
                    "name": "index"
                  },
                  "asyncModule": () => import('../src/routes/property/asset/[kind]/index.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_property_asset_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/property/asset/index.svelte",
                "dir": "src/routes/property/asset",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/property/asset/index.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_property_asset_loc",
              "name": "loc",
              "module": false,
              "file": {
                "path": "src/routes/property/asset/loc",
                "dir": "src/routes/property/asset",
                "base": "loc",
                "ext": "",
                "name": "loc"
              },
              "children": [
                {
                  "meta": {
                    "isDefault": true
                  },
                  "id": "_default_property_asset_loc_index_svelte",
                  "name": "index",
                  "file": {
                    "path": "src/routes/property/asset/loc/index.svelte",
                    "dir": "src/routes/property/asset/loc",
                    "base": "index.svelte",
                    "ext": ".svelte",
                    "name": "index"
                  },
                  "asyncModule": () => import('../src/routes/property/asset/loc/index.svelte'),
                  "children": []
                }
              ]
            }
          ]
        },
        {
          "meta": {},
          "id": "_default_property_finding",
          "name": "finding",
          "module": false,
          "file": {
            "path": "src/routes/property/finding",
            "dir": "src/routes/property",
            "base": "finding",
            "ext": "",
            "name": "finding"
          },
          "children": [
            {
              "meta": {
                "dynamic": true,
                "order": false
              },
              "id": "_default_property_finding__kind_",
              "name": "[kind]",
              "module": false,
              "file": {
                "path": "src/routes/property/finding/[kind]",
                "dir": "src/routes/property/finding",
                "base": "[kind]",
                "ext": "",
                "name": "[kind]"
              },
              "children": [
                {
                  "meta": {
                    "dynamic": true,
                    "order": false
                  },
                  "id": "_default_property_finding__kind___name_",
                  "name": "[name]",
                  "module": false,
                  "file": {
                    "path": "src/routes/property/finding/[kind]/[name]",
                    "dir": "src/routes/property/finding/[kind]",
                    "base": "[name]",
                    "ext": "",
                    "name": "[name]"
                  },
                  "children": [
                    {
                      "meta": {
                        "isDefault": true
                      },
                      "id": "_default_property_finding__kind___name__index_svelte",
                      "name": "index",
                      "file": {
                        "path": "src/routes/property/finding/[kind]/[name]/index.svelte",
                        "dir": "src/routes/property/finding/[kind]/[name]",
                        "base": "index.svelte",
                        "ext": ".svelte",
                        "name": "index"
                      },
                      "asyncModule": () => import('../src/routes/property/finding/[kind]/[name]/index.svelte'),
                      "children": []
                    },
                    {
                      "meta": {},
                      "id": "_default_property_finding__kind___name__values",
                      "name": "values",
                      "module": false,
                      "file": {
                        "path": "src/routes/property/finding/[kind]/[name]/values",
                        "dir": "src/routes/property/finding/[kind]/[name]",
                        "base": "values",
                        "ext": "",
                        "name": "values"
                      },
                      "children": [
                        {
                          "meta": {
                            "isDefault": true
                          },
                          "id": "_default_property_finding__kind___name__values_index_svelte",
                          "name": "index",
                          "file": {
                            "path": "src/routes/property/finding/[kind]/[name]/values/index.svelte",
                            "dir": "src/routes/property/finding/[kind]/[name]/values",
                            "base": "index.svelte",
                            "ext": ".svelte",
                            "name": "index"
                          },
                          "asyncModule": () => import('../src/routes/property/finding/[kind]/[name]/values/index.svelte'),
                          "children": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "meta": {
                    "isDefault": true
                  },
                  "id": "_default_property_finding__kind__index_svelte",
                  "name": "index",
                  "file": {
                    "path": "src/routes/property/finding/[kind]/index.svelte",
                    "dir": "src/routes/property/finding/[kind]",
                    "base": "index.svelte",
                    "ext": ".svelte",
                    "name": "index"
                  },
                  "asyncModule": () => import('../src/routes/property/finding/[kind]/index.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_property_finding_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/property/finding/index.svelte",
                "dir": "src/routes/property/finding",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/property/finding/index.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_property_finding_loc",
              "name": "loc",
              "module": false,
              "file": {
                "path": "src/routes/property/finding/loc",
                "dir": "src/routes/property/finding",
                "base": "loc",
                "ext": "",
                "name": "loc"
              },
              "children": [
                {
                  "meta": {
                    "isDefault": true
                  },
                  "id": "_default_property_finding_loc_index_svelte",
                  "name": "index",
                  "file": {
                    "path": "src/routes/property/finding/loc/index.svelte",
                    "dir": "src/routes/property/finding/loc",
                    "base": "index.svelte",
                    "ext": ".svelte",
                    "name": "index"
                  },
                  "asyncModule": () => import('../src/routes/property/finding/loc/index.svelte'),
                  "children": []
                }
              ]
            }
          ]
        },
        {
          "meta": {},
          "id": "_default_property_vulnerability",
          "name": "vulnerability",
          "module": false,
          "file": {
            "path": "src/routes/property/vulnerability",
            "dir": "src/routes/property",
            "base": "vulnerability",
            "ext": "",
            "name": "vulnerability"
          },
          "children": [
            {
              "meta": {
                "dynamic": true,
                "order": false
              },
              "id": "_default_property_vulnerability__kind_",
              "name": "[kind]",
              "module": false,
              "file": {
                "path": "src/routes/property/vulnerability/[kind]",
                "dir": "src/routes/property/vulnerability",
                "base": "[kind]",
                "ext": "",
                "name": "[kind]"
              },
              "children": [
                {
                  "meta": {
                    "dynamic": true,
                    "order": false
                  },
                  "id": "_default_property_vulnerability__kind___name_",
                  "name": "[name]",
                  "module": false,
                  "file": {
                    "path": "src/routes/property/vulnerability/[kind]/[name]",
                    "dir": "src/routes/property/vulnerability/[kind]",
                    "base": "[name]",
                    "ext": "",
                    "name": "[name]"
                  },
                  "children": [
                    {
                      "meta": {
                        "isDefault": true
                      },
                      "id": "_default_property_vulnerability__kind___name__index_svelte",
                      "name": "index",
                      "file": {
                        "path": "src/routes/property/vulnerability/[kind]/[name]/index.svelte",
                        "dir": "src/routes/property/vulnerability/[kind]/[name]",
                        "base": "index.svelte",
                        "ext": ".svelte",
                        "name": "index"
                      },
                      "asyncModule": () => import('../src/routes/property/vulnerability/[kind]/[name]/index.svelte'),
                      "children": []
                    },
                    {
                      "meta": {},
                      "id": "_default_property_vulnerability__kind___name__values",
                      "name": "values",
                      "module": false,
                      "file": {
                        "path": "src/routes/property/vulnerability/[kind]/[name]/values",
                        "dir": "src/routes/property/vulnerability/[kind]/[name]",
                        "base": "values",
                        "ext": "",
                        "name": "values"
                      },
                      "children": [
                        {
                          "meta": {
                            "isDefault": true
                          },
                          "id": "_default_property_vulnerability__kind___name__values_index_svelte",
                          "name": "index",
                          "file": {
                            "path": "src/routes/property/vulnerability/[kind]/[name]/values/index.svelte",
                            "dir": "src/routes/property/vulnerability/[kind]/[name]/values",
                            "base": "index.svelte",
                            "ext": ".svelte",
                            "name": "index"
                          },
                          "asyncModule": () => import('../src/routes/property/vulnerability/[kind]/[name]/values/index.svelte'),
                          "children": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "meta": {
                    "isDefault": true
                  },
                  "id": "_default_property_vulnerability__kind__index_svelte",
                  "name": "index",
                  "file": {
                    "path": "src/routes/property/vulnerability/[kind]/index.svelte",
                    "dir": "src/routes/property/vulnerability/[kind]",
                    "base": "index.svelte",
                    "ext": ".svelte",
                    "name": "index"
                  },
                  "asyncModule": () => import('../src/routes/property/vulnerability/[kind]/index.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_property_vulnerability_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/property/vulnerability/index.svelte",
                "dir": "src/routes/property/vulnerability",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/property/vulnerability/index.svelte'),
              "children": []
            }
          ]
        }
      ]
    },
    {
      "meta": {
        "reset": true
      },
      "id": "_default_register",
      "name": "register",
      "file": {
        "path": "src/routes/register/_reset.svelte",
        "dir": "src/routes/register",
        "base": "_reset.svelte",
        "ext": ".svelte",
        "name": "_reset"
      },
      "asyncModule": () => import('../src/routes/register/_reset.svelte'),
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_register_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/register/index.svelte",
            "dir": "src/routes/register",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/register/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {
        "reset": true
      },
      "id": "_default_register_request_success",
      "name": "register_request_success",
      "file": {
        "path": "src/routes/register_request_success/_reset.svelte",
        "dir": "src/routes/register_request_success",
        "base": "_reset.svelte",
        "ext": ".svelte",
        "name": "_reset"
      },
      "asyncModule": () => import('../src/routes/register_request_success/_reset.svelte'),
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_register_request_success_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/register_request_success/index.svelte",
            "dir": "src/routes/register_request_success",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/register_request_success/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_report",
      "name": "report",
      "module": false,
      "file": {
        "path": "src/routes/report",
        "dir": "src/routes",
        "base": "report",
        "ext": "",
        "name": "report"
      },
      "children": [
        {
          "meta": {},
          "id": "_default_report_list",
          "name": "list",
          "module": false,
          "file": {
            "path": "src/routes/report/list",
            "dir": "src/routes/report",
            "base": "list",
            "ext": "",
            "name": "list"
          },
          "children": [
            {
              "meta": {
                "noRoute": true
              },
              "id": "_default_report_list__form_svelte",
              "name": "_form",
              "file": {
                "path": "src/routes/report/list/_form.svelte",
                "dir": "src/routes/report/list",
                "base": "_form.svelte",
                "ext": ".svelte",
                "name": "_form"
              },
              "asyncModule": () => import('../src/routes/report/list/_form.svelte'),
              "children": []
            },
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_report_list_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/report/list/index.svelte",
                "dir": "src/routes/report/list",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/report/list/index.svelte'),
              "children": []
            }
          ]
        }
      ]
    },
    {
      "meta": {
        "reset": true
      },
      "id": "_default_signup",
      "name": "signup",
      "file": {
        "path": "src/routes/signup/_reset.svelte",
        "dir": "src/routes/signup",
        "base": "_reset.svelte",
        "ext": ".svelte",
        "name": "_reset"
      },
      "asyncModule": () => import('../src/routes/signup/_reset.svelte'),
      "children": [
        {
          "meta": {
            "reset": true
          },
          "id": "_default_signup_approve",
          "name": "approve",
          "file": {
            "path": "src/routes/signup/approve/_reset.svelte",
            "dir": "src/routes/signup/approve",
            "base": "_reset.svelte",
            "ext": ".svelte",
            "name": "_reset"
          },
          "asyncModule": () => import('../src/routes/signup/approve/_reset.svelte'),
          "children": [
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_signup_approve_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/signup/approve/index.svelte",
                "dir": "src/routes/signup/approve",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/signup/approve/index.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "reset": true
          },
          "id": "_default_signup_deny",
          "name": "deny",
          "file": {
            "path": "src/routes/signup/deny/_reset.svelte",
            "dir": "src/routes/signup/deny",
            "base": "_reset.svelte",
            "ext": ".svelte",
            "name": "_reset"
          },
          "asyncModule": () => import('../src/routes/signup/deny/_reset.svelte'),
          "children": [
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_signup_deny_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/signup/deny/index.svelte",
                "dir": "src/routes/signup/deny",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/signup/deny/index.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "reset": true
          },
          "id": "_default_signup_validate",
          "name": "validate",
          "file": {
            "path": "src/routes/signup/validate/_reset.svelte",
            "dir": "src/routes/signup/validate",
            "base": "_reset.svelte",
            "ext": ".svelte",
            "name": "_reset"
          },
          "asyncModule": () => import('../src/routes/signup/validate/_reset.svelte'),
          "children": [
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_signup_validate_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/signup/validate/index.svelte",
                "dir": "src/routes/signup/validate",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/signup/validate/index.svelte'),
              "children": []
            }
          ]
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_sla",
      "name": "sla",
      "module": false,
      "file": {
        "path": "src/routes/sla",
        "dir": "src/routes",
        "base": "sla",
        "ext": "",
        "name": "sla"
      },
      "children": [
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_sla_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/sla/index.svelte",
            "dir": "src/routes/sla",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/sla/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_snapshot",
      "name": "snapshot",
      "module": false,
      "file": {
        "path": "src/routes/snapshot",
        "dir": "src/routes",
        "base": "snapshot",
        "ext": "",
        "name": "snapshot"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_snapshot__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/snapshot/_components",
            "dir": "src/routes/snapshot",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_snapshot__components_comparison_modal_svelte",
              "name": "comparison-modal",
              "file": {
                "path": "src/routes/snapshot/_components/comparison-modal.svelte",
                "dir": "src/routes/snapshot/_components",
                "base": "comparison-modal.svelte",
                "ext": ".svelte",
                "name": "comparison-modal"
              },
              "asyncModule": () => import('../src/routes/snapshot/_components/comparison-modal.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_snapshot__components_report_modal_svelte",
              "name": "report-modal",
              "file": {
                "path": "src/routes/snapshot/_components/report-modal.svelte",
                "dir": "src/routes/snapshot/_components",
                "base": "report-modal.svelte",
                "ext": ".svelte",
                "name": "report-modal"
              },
              "asyncModule": () => import('../src/routes/snapshot/_components/report-modal.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_snapshot_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/snapshot/index.svelte",
            "dir": "src/routes/snapshot",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/snapshot/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_tag",
      "name": "tag",
      "module": false,
      "file": {
        "path": "src/routes/tag",
        "dir": "src/routes",
        "base": "tag",
        "ext": "",
        "name": "tag"
      },
      "children": [
        {
          "meta": {
            "dynamic": true,
            "order": false
          },
          "id": "_default_tag__id_",
          "name": "[id]",
          "module": false,
          "file": {
            "path": "src/routes/tag/[id]",
            "dir": "src/routes/tag",
            "base": "[id]",
            "ext": "",
            "name": "[id]"
          },
          "children": [
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_tag__id__index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/tag/[id]/index.svelte",
                "dir": "src/routes/tag/[id]",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/tag/[id]/index.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_tag__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/tag/_components",
            "dir": "src/routes/tag",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_tag__components_add_assets_tag_svelte",
              "name": "add-assets-tag",
              "file": {
                "path": "src/routes/tag/_components/add-assets-tag.svelte",
                "dir": "src/routes/tag/_components",
                "base": "add-assets-tag.svelte",
                "ext": ".svelte",
                "name": "add-assets-tag"
              },
              "asyncModule": () => import('../src/routes/tag/_components/add-assets-tag.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_tag__components_add_findings_tag_svelte",
              "name": "add-findings-tag",
              "file": {
                "path": "src/routes/tag/_components/add-findings-tag.svelte",
                "dir": "src/routes/tag/_components",
                "base": "add-findings-tag.svelte",
                "ext": ".svelte",
                "name": "add-findings-tag"
              },
              "asyncModule": () => import('../src/routes/tag/_components/add-findings-tag.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_tag__components_add_vulnerabilities_tag_svelte",
              "name": "add-vulnerabilities-tag",
              "file": {
                "path": "src/routes/tag/_components/add-vulnerabilities-tag.svelte",
                "dir": "src/routes/tag/_components",
                "base": "add-vulnerabilities-tag.svelte",
                "ext": ".svelte",
                "name": "add-vulnerabilities-tag"
              },
              "asyncModule": () => import('../src/routes/tag/_components/add-vulnerabilities-tag.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_tag__components_list_svelte",
              "name": "list",
              "file": {
                "path": "src/routes/tag/_components/list.svelte",
                "dir": "src/routes/tag/_components",
                "base": "list.svelte",
                "ext": ".svelte",
                "name": "list"
              },
              "asyncModule": () => import('../src/routes/tag/_components/list.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_tag__components_remove_tag_assets_svelte",
              "name": "remove-tag-assets",
              "file": {
                "path": "src/routes/tag/_components/remove-tag-assets.svelte",
                "dir": "src/routes/tag/_components",
                "base": "remove-tag-assets.svelte",
                "ext": ".svelte",
                "name": "remove-tag-assets"
              },
              "asyncModule": () => import('../src/routes/tag/_components/remove-tag-assets.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_tag__components_remove_tag_findings_svelte",
              "name": "remove-tag-findings",
              "file": {
                "path": "src/routes/tag/_components/remove-tag-findings.svelte",
                "dir": "src/routes/tag/_components",
                "base": "remove-tag-findings.svelte",
                "ext": ".svelte",
                "name": "remove-tag-findings"
              },
              "asyncModule": () => import('../src/routes/tag/_components/remove-tag-findings.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_tag__components_remove_tag_vulnerabilities_svelte",
              "name": "remove-tag-vulnerabilities",
              "file": {
                "path": "src/routes/tag/_components/remove-tag-vulnerabilities.svelte",
                "dir": "src/routes/tag/_components",
                "base": "remove-tag-vulnerabilities.svelte",
                "ext": ".svelte",
                "name": "remove-tag-vulnerabilities"
              },
              "asyncModule": () => import('../src/routes/tag/_components/remove-tag-vulnerabilities.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_tag__form_svelte",
          "name": "_form",
          "file": {
            "path": "src/routes/tag/_form.svelte",
            "dir": "src/routes/tag",
            "base": "_form.svelte",
            "ext": ".svelte",
            "name": "_form"
          },
          "asyncModule": () => import('../src/routes/tag/_form.svelte'),
          "children": []
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_tag__form_massive_add_svelte",
          "name": "_form_massive_add",
          "file": {
            "path": "src/routes/tag/_form_massive_add.svelte",
            "dir": "src/routes/tag",
            "base": "_form_massive_add.svelte",
            "ext": ".svelte",
            "name": "_form_massive_add"
          },
          "asyncModule": () => import('../src/routes/tag/_form_massive_add.svelte'),
          "children": []
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_tag_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/tag/index.svelte",
            "dir": "src/routes/tag",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/tag/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_user",
      "name": "user",
      "module": false,
      "file": {
        "path": "src/routes/user",
        "dir": "src/routes",
        "base": "user",
        "ext": "",
        "name": "user"
      },
      "children": [
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_user__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/user/_components",
            "dir": "src/routes/user",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_user__components_v2_list_svelte",
              "name": "v2-list",
              "file": {
                "path": "src/routes/user/_components/v2-list.svelte",
                "dir": "src/routes/user/_components",
                "base": "v2-list.svelte",
                "ext": ".svelte",
                "name": "v2-list"
              },
              "asyncModule": () => import('../src/routes/user/_components/v2-list.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_user__form_svelte",
          "name": "_form",
          "file": {
            "path": "src/routes/user/_form.svelte",
            "dir": "src/routes/user",
            "base": "_form.svelte",
            "ext": ".svelte",
            "name": "_form"
          },
          "asyncModule": () => import('../src/routes/user/_form.svelte'),
          "children": []
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_user__form_massive_add_svelte",
          "name": "_form_massive_add",
          "file": {
            "path": "src/routes/user/_form_massive_add.svelte",
            "dir": "src/routes/user",
            "base": "_form_massive_add.svelte",
            "ext": ".svelte",
            "name": "_form_massive_add"
          },
          "asyncModule": () => import('../src/routes/user/_form_massive_add.svelte'),
          "children": []
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_user_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/user/index.svelte",
            "dir": "src/routes/user",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/user/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {},
      "id": "_default_vulnerability",
      "name": "vulnerability",
      "module": false,
      "file": {
        "path": "src/routes/vulnerability",
        "dir": "src/routes",
        "base": "vulnerability",
        "ext": "",
        "name": "vulnerability"
      },
      "children": [
        {
          "meta": {
            "dynamic": true,
            "order": false
          },
          "id": "_default_vulnerability__id_",
          "name": "[id]",
          "module": false,
          "file": {
            "path": "src/routes/vulnerability/[id]",
            "dir": "src/routes/vulnerability",
            "base": "[id]",
            "ext": "",
            "name": "[id]"
          },
          "children": [
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_vulnerability__id__index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/vulnerability/[id]/index.svelte",
                "dir": "src/routes/vulnerability/[id]",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/vulnerability/[id]/index.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {
            "noRoute": true
          },
          "id": "_default_vulnerability__components",
          "name": "_components",
          "module": false,
          "file": {
            "path": "src/routes/vulnerability/_components",
            "dir": "src/routes/vulnerability",
            "base": "_components",
            "ext": "",
            "name": "_components"
          },
          "children": [
            {
              "meta": {},
              "id": "_default_vulnerability__components_cve_data_svelte",
              "name": "cve-data",
              "file": {
                "path": "src/routes/vulnerability/_components/cve-data.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "cve-data.svelte",
                "ext": ".svelte",
                "name": "cve-data"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/cve-data.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_graphics",
              "name": "graphics",
              "module": false,
              "file": {
                "path": "src/routes/vulnerability/_components/graphics",
                "dir": "src/routes/vulnerability/_components",
                "base": "graphics",
                "ext": "",
                "name": "graphics"
              },
              "children": [
                {
                  "meta": {},
                  "id": "_default_vulnerability__components_graphics_top_cve_svelte",
                  "name": "top-cve",
                  "file": {
                    "path": "src/routes/vulnerability/_components/graphics/top-cve.svelte",
                    "dir": "src/routes/vulnerability/_components/graphics",
                    "base": "top-cve.svelte",
                    "ext": ".svelte",
                    "name": "top-cve"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/_components/graphics/top-cve.svelte'),
                  "children": []
                },
                {
                  "meta": {},
                  "id": "_default_vulnerability__components_graphics_top_cwe_svelte",
                  "name": "top-cwe",
                  "file": {
                    "path": "src/routes/vulnerability/_components/graphics/top-cwe.svelte",
                    "dir": "src/routes/vulnerability/_components/graphics",
                    "base": "top-cwe.svelte",
                    "ext": ".svelte",
                    "name": "top-cwe"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/_components/graphics/top-cwe.svelte'),
                  "children": []
                },
                {
                  "meta": {},
                  "id": "_default_vulnerability__components_graphics_top_five_vuls_by_findings_svelte",
                  "name": "top-five-vuls-by-findings",
                  "file": {
                    "path": "src/routes/vulnerability/_components/graphics/top-five-vuls-by-findings.svelte",
                    "dir": "src/routes/vulnerability/_components/graphics",
                    "base": "top-five-vuls-by-findings.svelte",
                    "ext": ".svelte",
                    "name": "top-five-vuls-by-findings"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/_components/graphics/top-five-vuls-by-findings.svelte'),
                  "children": []
                },
                {
                  "meta": {},
                  "id": "_default_vulnerability__components_graphics_v2_top_cve_svelte",
                  "name": "v2-top-cve",
                  "file": {
                    "path": "src/routes/vulnerability/_components/graphics/v2-top-cve.svelte",
                    "dir": "src/routes/vulnerability/_components/graphics",
                    "base": "v2-top-cve.svelte",
                    "ext": ".svelte",
                    "name": "v2-top-cve"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/_components/graphics/v2-top-cve.svelte'),
                  "children": []
                },
                {
                  "meta": {},
                  "id": "_default_vulnerability__components_graphics_vulnerability_count_svelte",
                  "name": "vulnerability-count",
                  "file": {
                    "path": "src/routes/vulnerability/_components/graphics/vulnerability-count.svelte",
                    "dir": "src/routes/vulnerability/_components/graphics",
                    "base": "vulnerability-count.svelte",
                    "ext": ".svelte",
                    "name": "vulnerability-count"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/_components/graphics/vulnerability-count.svelte'),
                  "children": []
                },
                {
                  "meta": {},
                  "id": "_default_vulnerability__components_graphics_vuls_by_kind_svelte",
                  "name": "vuls-by-kind",
                  "file": {
                    "path": "src/routes/vulnerability/_components/graphics/vuls-by-kind.svelte",
                    "dir": "src/routes/vulnerability/_components/graphics",
                    "base": "vuls-by-kind.svelte",
                    "ext": ".svelte",
                    "name": "vuls-by-kind"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/_components/graphics/vuls-by-kind.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_list_svelte",
              "name": "list",
              "file": {
                "path": "src/routes/vulnerability/_components/list.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "list.svelte",
                "ext": ".svelte",
                "name": "list"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/list.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_note_add_svelte",
              "name": "note-add",
              "file": {
                "path": "src/routes/vulnerability/_components/note-add.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "note-add.svelte",
                "ext": ".svelte",
                "name": "note-add"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/note-add.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_note_svelte",
              "name": "note",
              "file": {
                "path": "src/routes/vulnerability/_components/note.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "note.svelte",
                "ext": ".svelte",
                "name": "note"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/note.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_remove_vulnerability_tag_svelte",
              "name": "remove-vulnerability-tag",
              "file": {
                "path": "src/routes/vulnerability/_components/remove-vulnerability-tag.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "remove-vulnerability-tag.svelte",
                "ext": ".svelte",
                "name": "remove-vulnerability-tag"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/remove-vulnerability-tag.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_severityTotals",
              "name": "severityTotals",
              "module": false,
              "file": {
                "path": "src/routes/vulnerability/_components/severityTotals",
                "dir": "src/routes/vulnerability/_components",
                "base": "severityTotals",
                "ext": "",
                "name": "severityTotals"
              },
              "children": [
                {
                  "meta": {},
                  "id": "_default_vulnerability__components_severityTotals_v2_severity_totals_svelte",
                  "name": "v2-severity-totals",
                  "file": {
                    "path": "src/routes/vulnerability/_components/severityTotals/v2-severity-totals.svelte",
                    "dir": "src/routes/vulnerability/_components/severityTotals",
                    "base": "v2-severity-totals.svelte",
                    "ext": ".svelte",
                    "name": "v2-severity-totals"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/_components/severityTotals/v2-severity-totals.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_v2_list_svelte",
              "name": "v2-list",
              "file": {
                "path": "src/routes/vulnerability/_components/v2-list.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "v2-list.svelte",
                "ext": ".svelte",
                "name": "v2-list"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/v2-list.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_vulnerability_basic_info_svelte",
              "name": "vulnerability-basic-info",
              "file": {
                "path": "src/routes/vulnerability/_components/vulnerability-basic-info.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "vulnerability-basic-info.svelte",
                "ext": ".svelte",
                "name": "vulnerability-basic-info"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/vulnerability-basic-info.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_vulnerability_description_svelte",
              "name": "vulnerability-description",
              "file": {
                "path": "src/routes/vulnerability/_components/vulnerability-description.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "vulnerability-description.svelte",
                "ext": ".svelte",
                "name": "vulnerability-description"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/vulnerability-description.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_vulnerability_detail_svelte",
              "name": "vulnerability-detail",
              "file": {
                "path": "src/routes/vulnerability/_components/vulnerability-detail.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "vulnerability-detail.svelte",
                "ext": ".svelte",
                "name": "vulnerability-detail"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/vulnerability-detail.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability__components_vulnerability_references_svelte",
              "name": "vulnerability-references",
              "file": {
                "path": "src/routes/vulnerability/_components/vulnerability-references.svelte",
                "dir": "src/routes/vulnerability/_components",
                "base": "vulnerability-references.svelte",
                "ext": ".svelte",
                "name": "vulnerability-references"
              },
              "asyncModule": () => import('../src/routes/vulnerability/_components/vulnerability-references.svelte'),
              "children": []
            }
          ]
        },
        {
          "meta": {},
          "id": "_default_vulnerability_custom",
          "name": "custom",
          "module": false,
          "file": {
            "path": "src/routes/vulnerability/custom",
            "dir": "src/routes/vulnerability",
            "base": "custom",
            "ext": "",
            "name": "custom"
          },
          "children": [
            {
              "meta": {
                "noRoute": true
              },
              "id": "_default_vulnerability_custom__components",
              "name": "_components",
              "module": false,
              "file": {
                "path": "src/routes/vulnerability/custom/_components",
                "dir": "src/routes/vulnerability/custom",
                "base": "_components",
                "ext": "",
                "name": "_components"
              },
              "children": [
                {
                  "meta": {
                    "noRoute": true
                  },
                  "id": "_default_vulnerability_custom__components__references_svelte",
                  "name": "_references",
                  "file": {
                    "path": "src/routes/vulnerability/custom/_components/_references.svelte",
                    "dir": "src/routes/vulnerability/custom/_components",
                    "base": "_references.svelte",
                    "ext": ".svelte",
                    "name": "_references"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/custom/_components/_references.svelte'),
                  "children": []
                }
              ]
            },
            {
              "meta": {
                "noRoute": true
              },
              "id": "_default_vulnerability_custom__form_svelte",
              "name": "_form",
              "file": {
                "path": "src/routes/vulnerability/custom/_form.svelte",
                "dir": "src/routes/vulnerability/custom",
                "base": "_form.svelte",
                "ext": ".svelte",
                "name": "_form"
              },
              "asyncModule": () => import('../src/routes/vulnerability/custom/_form.svelte'),
              "children": []
            },
            {
              "meta": {
                "isDefault": true
              },
              "id": "_default_vulnerability_custom_index_svelte",
              "name": "index",
              "file": {
                "path": "src/routes/vulnerability/custom/index.svelte",
                "dir": "src/routes/vulnerability/custom",
                "base": "index.svelte",
                "ext": ".svelte",
                "name": "index"
              },
              "asyncModule": () => import('../src/routes/vulnerability/custom/index.svelte'),
              "children": []
            },
            {
              "meta": {},
              "id": "_default_vulnerability_custom_logbook",
              "name": "logbook",
              "module": false,
              "file": {
                "path": "src/routes/vulnerability/custom/logbook",
                "dir": "src/routes/vulnerability/custom",
                "base": "logbook",
                "ext": "",
                "name": "logbook"
              },
              "children": [
                {
                  "meta": {
                    "dynamic": true,
                    "order": false
                  },
                  "id": "_default_vulnerability_custom_logbook__id_",
                  "name": "[id]",
                  "module": false,
                  "file": {
                    "path": "src/routes/vulnerability/custom/logbook/[id]",
                    "dir": "src/routes/vulnerability/custom/logbook",
                    "base": "[id]",
                    "ext": "",
                    "name": "[id]"
                  },
                  "children": [
                    {
                      "meta": {
                        "isDefault": true
                      },
                      "id": "_default_vulnerability_custom_logbook__id__index_svelte",
                      "name": "index",
                      "file": {
                        "path": "src/routes/vulnerability/custom/logbook/[id]/index.svelte",
                        "dir": "src/routes/vulnerability/custom/logbook/[id]",
                        "base": "index.svelte",
                        "ext": ".svelte",
                        "name": "index"
                      },
                      "asyncModule": () => import('../src/routes/vulnerability/custom/logbook/[id]/index.svelte'),
                      "children": []
                    }
                  ]
                },
                {
                  "meta": {
                    "noRoute": true
                  },
                  "id": "_default_vulnerability_custom_logbook__form_svelte",
                  "name": "_form",
                  "file": {
                    "path": "src/routes/vulnerability/custom/logbook/_form.svelte",
                    "dir": "src/routes/vulnerability/custom/logbook",
                    "base": "_form.svelte",
                    "ext": ".svelte",
                    "name": "_form"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/custom/logbook/_form.svelte'),
                  "children": []
                },
                {
                  "meta": {
                    "isDefault": true
                  },
                  "id": "_default_vulnerability_custom_logbook_index_svelte",
                  "name": "index",
                  "file": {
                    "path": "src/routes/vulnerability/custom/logbook/index.svelte",
                    "dir": "src/routes/vulnerability/custom/logbook",
                    "base": "index.svelte",
                    "ext": ".svelte",
                    "name": "index"
                  },
                  "asyncModule": () => import('../src/routes/vulnerability/custom/logbook/index.svelte'),
                  "children": []
                }
              ]
            }
          ]
        },
        {
          "meta": {
            "isDefault": true
          },
          "id": "_default_vulnerability_index_svelte",
          "name": "index",
          "file": {
            "path": "src/routes/vulnerability/index.svelte",
            "dir": "src/routes/vulnerability",
            "base": "index.svelte",
            "ext": ".svelte",
            "name": "index"
          },
          "asyncModule": () => import('../src/routes/vulnerability/index.svelte'),
          "children": []
        }
      ]
    },
    {
      "meta": {
        "dynamic": true,
        "dynamicSpread": true,
        "order": false,
        "inline": false
      },
      "name": "[...404]",
      "file": {
        "path": ".routify/components/[...404].svelte",
        "dir": ".routify/components",
        "base": "[...404].svelte",
        "ext": ".svelte",
        "name": "[...404]"
      },
      "asyncModule": () => import('./components/[...404].svelte'),
      "children": []
    }
  ]
}
export default routes